import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import { appActions } from '../appSlice'
import { BotId } from '@feedyou/schema'
import { openBotIdSelector } from '../selectors'

// We basically just mirror useParams().botId into the store in order to be able to access
// the id of currently open bot in store contexts (mostly thunks). Store.bot cannot be used
// for this, because it is only available once bot is loaded
export const useStoreOpenBotIdToAppSlice = (botId: BotId | undefined) => {
  const dispatch = useDispatch()
  const openBotId = useSelector(openBotIdSelector)

  useEffect(() => {
    dispatch(appActions.setOpenBotId(botId))
  }, [botId, dispatch])

  const isReady = openBotId === botId

  return isReady
}
